module.exports = __webpack_public_path__ + "static/media/django_logo.3c148946.png";